import { render, staticRenderFns } from "./RoomCallP2PVideo.vue?vue&type=template&id=5e7ce754&scoped=true&"
import script from "./RoomCallP2PVideo.vue?vue&type=script&lang=js&"
export * from "./RoomCallP2PVideo.vue?vue&type=script&lang=js&"
import style0 from "./RoomCallP2PVideo.vue?vue&type=style&index=0&id=5e7ce754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7ce754",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e7ce754')) {
      api.createRecord('5e7ce754', component.options)
    } else {
      api.reload('5e7ce754', component.options)
    }
    module.hot.accept("./RoomCallP2PVideo.vue?vue&type=template&id=5e7ce754&scoped=true&", function () {
      api.rerender('5e7ce754', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Call/p2p/RoomCallP2PVideo.vue"
export default component.exports